import axios from 'axios';

export const FETCH_DOWNLOADFCLAPPLE_BEGIN = 'FETCH_DOWNLOADFCLAPPLE_BEGIN';
export const FETCH_DOWNLOADFCLAPPLE_SUCCESS = 'FETCH_DOWNLOADFCLAPPLE_SUCCESS';
export const FETCH_DOWNLOADFCLAPPLE_FAILURE = 'FETCH_DOWNLOADFCLAPPLE_FAILURE';

export const fetchDownloadFCLAppleBegin = () => ({
    type: FETCH_DOWNLOADFCLAPPLE_BEGIN
});

export const fetchDownloadFCLAppleSuccess = DownloadFCLApple => ({
    type: FETCH_DOWNLOADFCLAPPLE_SUCCESS,
    payload: DownloadFCLApple
});

export const fetchDownloadFCLAppleFailure = error => ({
    type: FETCH_DOWNLOADFCLAPPLE_FAILURE,
    payload: { error }
});

export const getDownloadFCLAppleDetails = (webappurl, accessToken, arn) => {
    return dispatch => {
        dispatch(fetchDownloadFCLAppleBegin());

        const options = {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                'Accept': 'application/vnd.apple.pkpass',
                'Content-Type': 'application/json'                
            },
            responseType: 'blob'
        };

        var data = {
            individualArn: arn,
            passType: 'FCL'
        };

        return axios.post(webappurl + '/api/digitallicence/apple/v1/passes', data, options)
            .then(responseArr => {
                return dispatch(fetchDownloadFCLAppleSuccess(responseArr.data));
            })
            .catch(error => {
                return dispatch(fetchDownloadFCLAppleFailure(error.response ? error.response.data.errors : error));
            });
    };
};